import { useEffect, useState } from "react";
import { fetchUserProfile } from "./userProfiles";

function useUser(userId) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchUserData = async () => {
      try {
        setLoading(true);
        if (!userId) return;

        // Falls back to getUserProfiles when the rules refuse the read, which
        // they correctly do for anyone outside our organisation and bindings.
        const userData = await fetchUserProfile(userId);
        if (userData && isMounted) {
          setUser(userData);
        }
      } catch (err) {
        console.error("Error fetching user data:", err);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchUserData();
    return () => {
      isMounted = false;
    };
  }, [userId]);

  return { user, loading };
}

export default useUser;
